import { userRoles } from '@/server/constants'

export default function ({ store, redirect }) {
  if (!store.state.user.user || !(store.state.user.role & userRoles.admin)) {
    return redirect('/')
  }
}
